// Pages
import { SignInPage } from './sign-in.page';

export default SignInPage;
